import { IDsToClasses } from 'smg/html';
import * as template from 'smg/template';

export function DrawUse(item: HTMLElement, useText?: string, el: HTMLElement = template.Clone('#use-card-template')): HTMLElement {
    const itemParent = el.querySelector('.use-item');
    if (itemParent) {
        itemParent.appendChild(item);
    }

    if (useText) {
        const useEl = el.querySelector('.use');
        if (useEl) {
            useEl.textContent = useText;
        }
    }

    IDsToClasses(el);

    return el;
}